import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { RewardService } from 'src/app/core/api/reward/reward.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { RewardResponseDTO } from 'src/app/shared/models/dtos/responses/reward-response-dto/reward-response-dto';
import {
  generateSeriesChips,
  MultiSelectChip,
} from '../filter-container/filter-container.component';
import { FilterOptions } from 'src/app/shared/models/filters/filter-options';
import { RewardManagementService } from 'src/app/core/services/reward-management/reward-management.service';
import { PointSummaryDTO } from 'src/app/shared/models/dtos/responses/point-summary/point-summary-dto';

@Component({
  selector: 'app-reward-details',
  templateUrl: './reward-details.component.html',
  styleUrls: ['./reward-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Reward details information
 */
export class RewardDetailsComponent implements OnInit {
  @Input() reward!: RewardResponseDTO;
  redeemable: boolean = false;
  rewardRedeemDisclaimer = 'reward-redeem-disclaimer';
  loading = true;
  language = '';
  familyId!: number;

  pointSummary?: PointSummaryDTO;

  filters = {
    added: false,
    spend: false,
    expired: false,
    removed: false,
    startDate: undefined,
    endDate: undefined,
  };

  seriesChips: MultiSelectChip[] = [];

  seriesFilter: FilterOptions = {
    series: [],
  };

  /**
   * @constructor
   */
  constructor(
    public translationService: TranslationService,
    public readonly rewardManagementService: RewardManagementService,
    private rewardService: RewardService
  ) {}

  /**
   * On init
   */
  ngOnInit() {
    this.language = this.translationService.getActiveLang();
    // TODO Check redeemable
    this.rewardService.checkRedeemable(this.reward.id).subscribe((res) => {
      this.loading = false;
      this.redeemable = res.message === 'true';
    });
    this.rewardService
      .getSeriesAvailableToRedeem(this.reward.id)
      .subscribe((response) => {
        this.seriesChips = generateSeriesChips(response);
      });
    this.translationService
      .translateString(this.rewardRedeemDisclaimer)
      .then((res) => (this.rewardRedeemDisclaimer = res));
  }

  /**
   * Updates Filters
   * @param {FilterOptions} filters
   */
  updateFilter(filters: FilterOptions) {
    this.filters = { ...this.filters, ...filters };

    this.seriesFilter = {
      series: filters.series,
    };
    this.familyId = parseInt(this.seriesFilter.series![0]);
    if (filters.series && filters.series.length > 0) {
      this.rewardManagementService
        .pullPoints(parseInt(this.seriesFilter.series![0]))
        .then((result) => {
          this.pointSummary = result;
        });
    }
  }
}
